export default function Button({ children, variant = 'primary', size = 'md', className = '', ...props }) {
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base',
  }
  const base = `inline-flex items-center gap-2 rounded font-semibold transition-all duration-200 cursor-pointer ${sizes[size]} ${className}`
  if (variant === 'primary') return <button className={`btn-primary ${base}`} {...props}>{children}</button>
  if (variant === 'ghost')   return <button className={`btn-ghost ${base}`} {...props}>{children}</button>
  if (variant === 'outline') return (
    <button className={`${base} border border-theme-strong text-accent hover:bg-sunk`} {...props}>
      {children}
    </button>
  )
  return <button className={`${base} btn-primary`} {...props}>{children}</button>
}
